/**
 * TKP-114 — Varlıklar birim kartındaki YAZMA eylemleri (düzenle / sil / tamamlandı) kimin için görünür?
 *
 * Kural backend'in `DepartmentAuthority.canEdit` kuralıyla birebir aynı: `DEPARTMENT_EDIT` yeteneği VEYA o birimin
 * yetkilisi olmak. Eskiden bileşende üç eylem de koşulsuzdu; Risk Yöneticisi ve İç Kontrol düğmeleri görüyor, basınca
 * 403 alıyordu. Saf: store ve bileşenden bağımsız.
 */

/** Birimin yetkilisi miyim? `admins` ACL kayıtları hesapla birlikte döner (adapter populate'i); kimlik ya da nesne olabilir. */
export const isDepartmentAdmin = (department, accountId) =>
  !!accountId &&
  (department?.admins ?? []).some((admin) => {
    const account = admin?.account;
    const id = account && typeof account === "object" ? account._id : account;
    return String(id) === String(accountId);
  });

/** Yazma eylemleri görünür mü? */
export const canEditDepartment = (department, { hasCapability = false, accountId } = {}) => !!hasCapability || isDepartmentAdmin(department, accountId);
